import React, {useState, useEffect} from 'react';
import styles from './PrivacyPolicyPage.module.css';

const PrivacyPolicyPage = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };

        // Таймер для "времени чтения"
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
            clearInterval(timer);
        };
    }, []);

    // Расчет "времени чтения" (шутка)
    const readingTime = Math.max(5, Math.floor(Math.random() * 20));

    return (
        <div className={styles.privacyPage}>
            <div className={styles.privacyContainer}>
                <div className={styles.headerSection}>
                    <h1 className={styles.pageTitle}>Политика конфиденциальности</h1>
                    <div className={styles.subtitle}>
                        Самый скучный документ на сайте, но очень важный! 📜
                    </div>

                    <div className={styles.metaInfo}>
                        <div className={styles.metaItem}>
                            <span className={styles.metaIcon}>⏱️</span>
                            <span>Примерное время чтения: {readingTime} минут</span>
                        </div>
                        <div className={styles.metaItem}>
                            <span className={styles.metaIcon}>📅</span>
                            <span>Последнее обновление: {currentTime.toLocaleDateString()}</span>
                        </div>
                        <div className={styles.metaItem}>
                            <span className={styles.metaIcon}>☕</span>
                            <span>Рекомендуется с кружкой кофе</span>
                        </div>
                    </div>
                </div>

                <div className={`${styles.navigation} ${isScrolled ? styles.scrolled : ''}`}>
                    <h2>🚀 Быстрая навигация:</h2>
                    <div className={styles.navItems}>
                        <a href="#section1" className={styles.navLink}>1. Общие положения</a>
                        <a href="#section2" className={styles.navLink}>2. Термины</a>
                        <a href="#section3" className={styles.navLink}>3. Обработка данных</a>
                        <a href="#section4" className={styles.navLink}>4. Защита данных</a>
                        <a href="#section5" className={styles.navLink}>5. Права и обязанности</a>
                        <a href="#section6" className={styles.navLink}>6. Заключение</a>
                    </div>
                </div>

                <div className={styles.content}>
                    {/* Остальное содержимое остается таким же, но с добавлением стилей */}

                    <section id="section1" className={styles.section}>
                        <h2 className={styles.sectionTitle}>
                            <span className={styles.sectionNumber}>1.</span>
                            Общие положения
                        </h2>
                        <p className={styles.paragraph}>

                            <strong>1.1.</strong> Настоящая Политика в отношении обработки персональных данных (далее -
                            Политика)
                            составлена в соответствии с пунктом 2 статьи 18.1 Федерального закона «О персональных
                            данных»
                            № 152-ФЗ от 27 июля 2006 г., а также иными нормативно-правовыми актами Российской Федерации
                            в области защиты и обработки персональных данных и действует в отношении всех персональных
                            данных
                            (далее - Данные), которые Администрация сайта "Vivera Blog" (расположенный
                            http://79.133.181.74/), (далее - Оператор) может получить от субъекта
                            персональных данных,
                            являющегося стороной по гражданско-правовому договору.
                        </p>
                        <p className={styles.paragraph}>
                            <strong>1.2.</strong> Оператор обеспечивает защиту обрабатываемых персональных данных от
                            несанкционированного
                            доступа и разглашения, неправомерного использования или утраты в соответствии с требованиями
                            Федерального закона от 27 июля 2006 г. № 152-ФЗ «О персональных данных».
                        </p>
                        <div className={styles.highlight}>
                            <h3 className={styles.subsectionTitle}>1.3. Изменение Политики</h3>
                            <p className={styles.paragraph}>
                                <strong>1.3.1.</strong> Оператор имеет право вносить изменения в настоящую Политику. При
                                внесении изменений
                                в заголовке Политики указывается дата последнего обновления редакции. Новая редакция
                                Политики
                                вступает в силу с момента ее размещения на сайте, если иное не предусмотрено новой
                                редакцией Политики.
                            </p>
                        </div>
                    </section>

                    <section id="section2" className={styles.section}>
                        <h2 className={styles.sectionTitle}>
                            <span className={styles.sectionNumber}>2.</span>
                            Термины
                        </h2>
                        <div className={styles.definitionList}>
                            <div className={styles.definitionItem}>
                                <strong>Персональные данные (ПД)</strong> - любая информация, относящаяся к прямо или
                                косвенно
                                определенному или определяемому физическому лицу (субъекту персональных данных).
                            </div>
                            <div className={styles.definitionItem}>
                                <strong>Обработка персональных данных</strong> - любое действие (операция) или
                                совокупность действий
                                (операций), совершаемых с использованием средств автоматизации или без использования
                                таких средств
                                с персональными данными, включая сбор, запись, систематизацию, накопление, хранение,
                                уточнение
                                (обновление, изменение), извлечение, использование, передачу (распространение,
                                предоставление, доступ),
                                обезличивание, блокирование, удаление, уничтожение персональных данных.
                            </div>
                            <div className={styles.definitionItem}>
                                <strong>Автоматизированная обработка персональных данных</strong> - обработка
                                персональных данных
                                с помощью средств вычислительной техники.
                            </div>
                            <div className={styles.definitionItem}>
                                <strong>Информационная система персональных данных (ИСПД)</strong> - совокупность
                                содержащихся
                                в базах данных персональных данных и обеспечивающих их обработку информационных
                                технологий и технических средств.
                            </div>
                            <div className={styles.definitionItem}>
                                <strong>Персональные данные, сделанные общедоступными субъектом персональных
                                    данных</strong> - ПД,
                                доступ неограниченного круга лиц к которым предоставлен субъектом персональных данных
                                либо по его просьбе.
                            </div>
                            <div className={styles.definitionItem}>
                                <strong>Блокирование персональных данных</strong> - временное прекращение обработки
                                персональных данных
                                (за исключением случаев, если обработка необходима для уточнения персональных данных).
                            </div>
                            <div className={styles.definitionItem}>
                                <strong>Уничтожение персональных данных</strong> - действия, в результате которых
                                становится невозможным
                                восстановить содержание персональных данных в информационной системе персональных данных
                                и (или)
                                в результате которых уничтожаются материальные носители персональных данных.
                            </div>
                            <div className={styles.definitionItem}>
                                <strong>Оператор</strong> — организация, самостоятельно или совместно с другими лицами
                                организующая
                                обработку персональных данных, а также определяющая цели обработки персональных данных,
                                подлежащих обработке, действия (операции), совершаемые с персональными данными.
                            </div>
                            <div className={styles.definitionItem}>
                                <strong>Cookies</strong> — небольшой фрагмент данных, отправленный веб-сервером и
                                хранимый на компьютере
                                пользователя, который веб-клиент или веб-браузер каждый раз пересылает веб-серверу в
                                HTTP-запросе
                                при попытке открыть страницу Сайта.
                            </div>
                        </div>
                    </section>
                    <section id="section3" className={styles.section}>
                        <h2 className={styles.sectionTitle}>
                            <span className={styles.sectionNumber}>3.</span>
                            Обработка персональных данных
                        </h2>
                        <h3 className={styles.subsectionTitle}>3.1. Получение ПД</h3>
                        <p className={styles.paragraph}>
                            <strong>3.1.1.</strong> Все ПД следует получать от самого субъекта. Если ПД субъекта можно
                            получить только
                            у третьей стороны, то субъект должен быть уведомлен об этом или от него должно быть получено
                            согласие.
                        </p>
                        <p className={styles.paragraph}>
                            <strong>3.1.2.</strong> Оператор должен сообщить субъекту о целях, предполагаемых источниках
                            и способах
                            получения ПД, характере подлежащих получению ПД, перечне действий с ПД, сроке, в течение
                            которого
                            действует согласие, и порядке его отзыва, а также о последствиях отказа субъекта дать
                            письменное
                            согласие на их получение.
                        </p>
                        <p className={styles.paragraph}>
                            <strong>3.1.3.</strong> Оператор получает ПД в результате внесения сведений в учетные формы.
                        </p>
                        <p className={styles.paragraph}>
                            <strong>3.1.4.</strong> При авторизации пользователя происходит сохранение хэша в cookies
                            клиентского
                            браузера с целью запоминания ранее произведенной авторизации. Отключение cookies может
                            повлечь
                            невозможность доступа к частям Сайта, требующим авторизации.
                        </p>

                        <h3 className={styles.subsectionTitle}>3.2. Обработка ПД</h3>
                        <p className={styles.paragraph}>
                            <strong>3.2.1.</strong> Обработка персональных данных осуществляется:
                        </p>
                        <ul className={styles.list}>
                            <li>с согласия субъекта персональных данных на обработку его персональных данных;</li>
                            <li>в случаях, когда обработка персональных данных необходима для осуществления и выполнения
                                возложенных законодательством РФ функций, полномочий и обязанностей;
                            </li>
                            <li>в случаях, когда осуществляется обработка персональных данных, доступ неограниченного
                                круга лиц к которым предоставлен субъектом персональных данных либо по его просьбе
                                (далее - персональные данные, сделанные общедоступными субъектом персональных данных).
                            </li>
                        </ul>
                        <p className={styles.paragraph}>
                            <strong>3.2.2.</strong> Цели обработки персональных данных:
                        </p>
                        <ul className={styles.list}>
                            <li>осуществление гражданско-правовых отношений;</li>
                            <li>предоставление доступа к сервисам и функционалу сайта;</li>
                            <li>информирование о новых возможностях и обновлениях;</li>
                            <li>обеспечение безопасности и предотвращение мошенничества.</li>
                        </ul>
                        <p className={styles.paragraph}>
                            <strong>3.2.3.</strong> Категории субъектов персональных данных. Обрабатываются ПД следующих
                            субъектов ПД:
                        </p>
                        <ul className={styles.list}>
                            <li>физические лица, состоящие с Оператором в гражданско-правовых отношениях;</li>
                            <li>пользователи сайта, зарегистрировавшие учетную запись;</li>
                            <li>посетители сайта, оставившие какие-либо данные через формы обратной связи.</li>
                        </ul>
                        <p className={styles.paragraph}>
                            <strong>3.2.4.</strong> ПД, обрабатываемые Оператором:
                        </p>
                        <ul className={styles.list}>
                            <li>данные, полученные при осуществлении гражданско-правовых отношений;</li>
                            <li>имя, адрес электронной почты, данные учетной записи;</li>
                            <li>информация о действиях пользователя на сайте;</li>
                            <li>технические данные (IP-адрес, тип браузера, данные cookies).</li>
                        </ul>
                        <p className={styles.paragraph}>
                            <strong>3.2.5.</strong> Обработка персональных данных ведется с использованием средств
                            автоматизации.
                        </p>

                        <h3 className={styles.subsectionTitle}>3.3. Хранение ПД</h3>
                        <p className={styles.paragraph}>
                            <strong>3.3.1.</strong> ПД субъектов могут быть получены, проходить дальнейшую обработку и
                            передаваться
                            на хранение в электронном виде.
                        </p>
                        <p className={styles.paragraph}>
                            <strong>3.3.2.</strong> ПД субъектов, обрабатываемые с использованием средств автоматизации
                            в разных целях,
                            хранятся в электронном виде в базе данных персональных данных.
                        </p>
                        <p className={styles.paragraph}>
                            <strong>3.3.3.</strong> Не допускается хранение и размещение документов, содержащих ПД, в
                            открытых
                            электронных каталогах (файлообменниках) в ИСПД.
                        </p>
                        <p className={styles.paragraph}>
                            <strong>3.3.4.</strong> Хранение ПД в форме, позволяющей определить субъекта ПД,
                            осуществляется не дольше,
                            чем этого требуют цели их обработки, и они подлежат уничтожению по достижении целей
                            обработки
                            или в случае утраты необходимости в их достижении.
                        </p>

                        <h3 className={styles.subsectionTitle}>3.4. Уничтожение ПД</h3>
                        <p className={styles.paragraph}>
                            <strong>3.4.1.</strong> ПД на электронных носителях уничтожаются путем стирания или
                            форматирования носителя.
                        </p>
                        <p className={styles.paragraph}>
                            <strong>3.4.2.</strong> Документы, содержащие ПД, уничтожаются с помощью шредера или иным
                            способом,
                            исключающим возможность восстановления информации.
                        </p>

                        <h3 className={styles.subsectionTitle}>3.5. Передача ПД</h3>
                        <p className={styles.paragraph}>
                            <strong>3.5.1.</strong> Оператор передает ПД третьим лицам в следующих случаях:
                        </p>
                        <ul className={styles.list}>
                            <li>субъект выразил свое согласие на такие действия;</li>
                            <li>передача предусмотрена российским или иным применимым законодательством в рамках
                                установленной законодательством процедуры;
                            </li>
                            <li>для обеспечения функционирования сайта и предоставления услуг (хостинг-провайдерам,
                                техническим службам).
                            </li>
                        </ul>
                        <p className={styles.paragraph}>
                            <strong>3.5.2.</strong> Перечень лиц, которым передаются ПД:
                        </p>
                        <ul className={styles.list}>
                            <li>партнеры Оператора;</li>
                            <li>поставщики услуг, обеспечивающие работу сайта и его функциональность;</li>
                            <li>государственные органы в случаях, предусмотренных законодательством.</li>
                        </ul>
                    </section>
                    <section id="section4" className={styles.section}>
                        <h2 className={styles.sectionTitle}>
                            <span className={styles.sectionNumber}>4.</span>
                            Защита персональных данных
                        </h2>
                        <p className={styles.paragraph}>
                            <strong>4.1.</strong> Основными мерами защиты ПД, используемыми Оператором, являются:
                        </p>
                        <div className={styles.protectionList}>
                            <div className={styles.protectionItem}>
                                <h4>4.1.1. Ответственное лицо</h4>
                                <p>Назначение лица, ответственного за обработку ПД, которое осуществляет организацию
                                    обработки ПД, внутренний контроль за соблюдением учреждением и его работниками
                                    требований к защите ПД.</p>
                            </div>
                            <div className={styles.protectionItem}>
                                <h4>4.1.2. Анализ угроз</h4>
                                <p>Определение актуальных угроз безопасности ПД при их обработке в ИСПД и разработка мер
                                    и мероприятий по защите ПД.</p>
                            </div>
                            <div className={styles.protectionItem}>
                                <h4>4.1.3. Политика обработки</h4>
                                <p>Разработка политики в отношении обработки персональных данных.</p>
                            </div>
                            <div className={styles.protectionItem}>
                                <h4>4.1.4. Контроль доступа</h4>
                                <p>Установление индивидуальных паролей доступа сотрудников в информационную систему в
                                    соответствии с их производственными обязанностями.</p>
                            </div>
                            <div className={styles.protectionItem}>
                                <h4>4.1.5. Сохранность данных</h4>
                                <p>Соблюдение условий, обеспечивающих сохранность ПД и исключающих несанкционированный к
                                    ним доступ.</p>
                            </div>
                            <div className={styles.protectionItem}>
                                <h4>4.1.6. Обнаружение нарушений</h4>
                                <p>Обнаружение фактов несанкционированного доступа к персональным данным и принятие
                                    мер.</p>
                            </div>
                            <div className={styles.protectionItem}>
                                <h4>4.1.7. Восстановление данных</h4>
                                <p>Восстановление ПД, модифицированных или уничтоженных вследствие несанкционированного
                                    доступа к ним.</p>
                            </div>
                            <div className={styles.protectionItem}>
                                <h4>4.1.8. Обучение сотрудников</h4>
                                <p>Ознакомление работников Оператора, непосредственно осуществляющих обработку
                                    персональных данных, положениям законодательства РФ о персональных данных, в том
                                    числе требованиям к защите персональных данных, документам, определяющим политику
                                    Оператора в отношении обработки персональных данных, локальным актам по вопросам
                                    обработки персональных данных.</p>
                            </div>
                            <div className={styles.protectionItem}>
                                <h4>4.1.9. Внутренний контроль</h4>
                                <p>Осуществление внутреннего контроля и аудита обработки персональных данных.</p>
                            </div>
                        </div>
                    </section>
                    <section id="section5" className={styles.section}>
                        <h2 className={styles.sectionTitle}>
                            <span className={styles.sectionNumber}>5.</span>
                            Основные права субъекта ПД и обязанности Оператора
                        </h2>
                        <h3 className={styles.subsectionTitle}>5.1. Основные права субъекта ПД</h3>
                        <p className={styles.paragraph}>
                            Субъект имеет право на доступ к его персональным данным и следующим сведениям:
                        </p>
                        <ul className={styles.list}>
                            <li>подтверждение факта обработки ПД Оператором;</li>
                            <li>правовые основания и цели обработки ПД;</li>
                            <li>цели и применяемые Оператором способы обработки ПД;</li>
                            <li>сведения о лицах (за исключением работников Оператора), которые имеют доступ к ПД или
                                которым могут быть раскрыты ПД на основании договора с Оператором или на основании
                                федерального закона;
                            </li>
                            <li>сроки обработки персональных данных, в том числе сроки их хранения;</li>
                            <li>порядок осуществления субъектом ПД прав, предусмотренных настоящим Федеральным
                                законом;
                            </li>
                            <li>обращение к Оператору и направление ему запросов;</li>
                            <li>обжалование действий или бездействия Оператора.</li>
                        </ul>

                        <h3 className={styles.subsectionTitle}>5.2. Обязанности Оператора</h3>
                        <p className={styles.paragraph}>Оператор обязан:</p>
                        <ul className={styles.list}>
                            <li>при сборе ПД предоставить информацию об обработке ПД;</li>
                            <li>при отказе в предоставлении ПД субъекту разъясняются последствия такого отказа;</li>
                            <li>опубликовать или иным образом обеспечить неограниченный доступ к документу,
                                определяющему его политику в отношении обработки ПД, к сведениям о реализуемых
                                требованиях к защите ПД;
                            </li>
                            <li>принимать необходимые правовые, организационные и технические меры или обеспечивать их
                                принятие для защиты ПД от неправомерного или случайного доступа к ним, уничтожения,
                                изменения, блокирования, копирования, предоставления, распространения ПД, а также от
                                иных неправомерных действий в отношении ПД;
                            </li>
                            <li>давать ответы на запросы и обращения субъектов ПД, их представителей и уполномоченного
                                органа по защите прав субъектов ПД.
                            </li>
                        </ul>
                    </section>
                    <section id="section6" className={styles.section}>
                        <h2 className={styles.sectionTitle}>
                            <span className={styles.sectionNumber}>6.</span>
                            Заключительные положения
                        </h2>
                        <p className={styles.paragraph}>
                            <strong>6.1.</strong> Настоящая Политика конфиденциальности является публичным документом,
                            доступным
                            любому пользователю сети Интернет при переходе по ссылке "Политика конфиденциальности"
                            в нижней части сайта.
                        </p>
                        <p className={styles.paragraph}>
                            <strong>6.2.</strong> Оператор вправе вносить изменения в настоящую Политику. При внесении
                            изменений
                            в заголовке Политики указывается дата последнего обновления редакции.
                        </p>
                        <p className={styles.paragraph}>
                            <strong>6.3.</strong> К настоящей Политике и отношениям между субъектом ПД и Оператором,
                            возникающим
                            в связи с применением Политики конфиденциальности, подлежит применению право Российской
                            Федерации.
                        </p>
                        <p className={styles.paragraph}>
                            <strong>6.4.</strong> Все предложения или вопросы по поводу настоящей Политики следует
                            сообщать
                            через форму обратной связи на сайте или по электронной почте, указанной в разделе
                            "Контакты".
                        </p>
                        <p className={styles.paragraph}>
                            <strong>6.5.</strong> Действующая редакция Политики конфиденциальности размещена на странице
                            по адресу:
                            https://viverablog.ru/privacy-policy
                        </p>
                    </section>


                    <div className={styles.funFact}>
                        <h3>Знаете ли вы? 🤓</h3>
                        <p>
                            Прочитав эту политику конфиденциальности, вы официально стали экспертом
                            в области защиты персональных данных! Наши поздравления! 🎓
                        </p>
                        <p className={styles.smallText}>
                            (Это шутка, пожалуйста, не указывайте это в резюме)
                        </p>
                    </div>

                    <div className={styles.actions}>
                        <button
                            className={styles.actionButton}
                            onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}
                        >
                            📍 Наверх
                        </button>
                        <button
                            className={styles.actionButtonSecondary}
                            onClick={() => window.print()}
                        >
                            🖨️ Распечатать
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicyPage;